module.exports = __webpack_public_path__ + "static/media/withdr.bcdb4aa9.svg";